import {H3, P} from '@/typography';
import {SectionPadding} from '@/section';
import Container from '@/container';
import {Grid} from '@/grid';
import {withBgYellow50} from '@/hocs/withColors';
import {GridLayout, GridItem} from '@/ui/grid/grid-layout';
import BoxGrid from '@/ui/box-grid';

const Yellow50Section = withBgYellow50(SectionPadding);

const UsefulLinksArray = [
  {
    url: 'https://vdp.workable.com/',
    urlCopy: 'Report a bug',
    title: 'Vulnerability report',
    copy: 'We welcome external feedback and encourage everyone to report bugs. To view our vulnerability disclosure policy or submit a report, please click below; all reports are then processed internally.',
    target: '_blank'
  },
  {
    url: '/privacy',
    urlCopy: 'Read our privacy policy',
    title: 'Privacy policy',
    copy: 'We take data protection seriously. Review our comprehensive privacy policy to understand our data handling procedures.'
  }
];

const UsefulLinks = () => (
  <Yellow50Section>
    <Container>
      <Grid fluid>
        <GridLayout Col={2} lgCol={2} autoRows>
          {UsefulLinksArray.map((item, index) => (
            <GridItem key={index}>
              <BoxGrid
                backgroundColor="var(--yellow100)"
                Url={item.url}
                UrlCopy={item.urlCopy}
                {...(item.target && {target: item.target})}>
                <H3>{item.title}</H3>
                <P>{item.copy}</P>
              </BoxGrid>
            </GridItem>
          ))}
        </GridLayout>
      </Grid>
    </Container>
  </Yellow50Section>
);

export default UsefulLinks;
